import { FeedItem } from '@model';
import { Action } from '@ngrx/store';

export enum FeedActionTypes {
    LoadFeedData = '[Feed] Load',
    LoadFeedDataSuccess = '[Feed] Load success',
    LoadFeedDataFail = '[Feed] Load fail',
    ClearFeedData = '[Feed] Clear'
}

export class LoadFeed implements Action {
    readonly type = FeedActionTypes.LoadFeedData;
    constructor() {}
  }
  export class LoadFeedSuccess implements Action {
    readonly type = FeedActionTypes.LoadFeedDataSuccess;
    constructor(public payload: FeedItem[]) {}
  }
  export class LoadFeedFail implements Action {
    readonly type = FeedActionTypes.LoadFeedDataFail;
    constructor(public payload: any) {}
  }


export class ClearFeed implements Action {
    readonly type = FeedActionTypes.ClearFeedData;
    constructor() { }
}

export type FeedActions =
    LoadFeed
    | LoadFeedSuccess
    | LoadFeedFail
    | ClearFeed;